import { Component } from '@angular/core';

@Component({
	selector: 'app-cancel-intake-form-confirmation-modal',
	templateUrl: './cancel-intake-form-confirmation-modal.component.html',
	imports: [],
})
export class CancelIntakeFormConfirmationModalComponent {}
